import styled from '@emotion/styled';
import { isArchivedTracker } from '@racemap/utilities/functions/validation';
import type { FC } from 'react';
import { toast } from 'react-toastify';
import { useTrackersForAction } from '../../../lib/customHooks';
import { useStore } from '../../../store/reducers';

export type Props = {
  btnStyle: object;
  btnClass?: string;
};

// TODO: remove with the old tracker managment

export const RevokeAllMessagesButton: FC = () => {
  const trackersToUse = useTrackersForAction();
  const { revokeAllTrackerMessages } = useStore((s) => s.trackers.actions);

  if (trackersToUse == null) return <></>;

  // change of the activation state + activationDate (in case of a not activated) of a tracker for each tracker -> permission check with trackerUpdateFilters in gears-api/helpers/filters.ts (is the current user allowed to change the state)
  const handleClick = async () => {
    const trackersToUseIds = trackersToUse
      .filter((tracker) => !isArchivedTracker(tracker))
      .map((tracker) => tracker.id);

    revokeAllTrackerMessages(trackersToUseIds);

    toast.success('Revoked all pending messages');
  };

  return (
    <Container onClick={() => handleClick()}>
      <div>Revoke pending messages</div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;
